import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import SearchOverlay from "./SearchOverlay";

const navItems = [
  { label: "首页", path: "/" },
  { label: "影视分类", path: "/category" },
  { label: "影视资讯", path: "/news" },
  { label: "关于我们", path: "/about" },
];

export default function Navbar() {
  const { pathname } = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  const isActive = (path: string) =>
    path === "/" ? pathname === "/" : pathname.startsWith(path);

  return (
    <>
      <header
        className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
          scrolled
            ? "border-b border-background-200 bg-background-50/95 backdrop-blur"
            : "bg-background-50/80 backdrop-blur"
        }`}
      >
        <div className="mx-auto flex h-16 w-full items-center gap-4 px-4 md:px-6">
          <Link to="/" className="flex shrink-0 items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-movie-2-line text-xl"></i>
            </span>
            <span className="text-lg font-extrabold tracking-tight text-foreground-950 font-heading">
              久久爱
            </span>
          </Link>

          <nav className="ml-4 hidden items-center gap-1 md:flex">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`cursor-pointer rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                  isActive(item.path)
                    ? "bg-primary-50 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <div className="ml-auto flex items-center gap-2">
            <button
              type="button"
              onClick={() => setSearchOpen(true)}
              className="hidden cursor-pointer items-center gap-2 rounded-full border border-background-300 bg-background-50 px-4 py-2 text-sm text-foreground-500 transition-colors hover:border-primary-300 hover:text-foreground-700 md:flex"
            >
              <i className="ri-search-line text-base"></i>
              <span>搜索影视作品</span>
            </button>
            <button
              type="button"
              onClick={() => setSearchOpen(true)}
              aria-label="搜索"
              className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full text-foreground-700 transition-colors hover:bg-background-100 md:hidden"
            >
              <i className="ri-search-line text-xl"></i>
            </button>
            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              aria-label="菜单"
              className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full text-foreground-700 transition-colors hover:bg-background-100 md:hidden"
            >
              <i className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
            </button>
          </div>
        </div>

        {menuOpen && (
          <div className="border-t border-background-200 bg-background-50 px-4 py-2 md:hidden">
            <nav className="flex flex-col">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`cursor-pointer rounded-md px-3 py-3 text-sm font-medium transition-colors ${
                    isActive(item.path)
                      ? "bg-primary-50 text-primary-700"
                      : "text-foreground-700 hover:bg-background-100"
                  }`}
                >
                  {item.label}
                </Link>
              ))}
            </nav>
          </div>
        )}
      </header>

      <SearchOverlay open={searchOpen} onClose={() => setSearchOpen(false)} />
    </>
  );
}